interface ProjectTestimonial {
  quote: string
  author: string
  role?: string
}

interface ProjectTestimonialProps {
  testimonial: ProjectTestimonial
}

export function ProjectTestimonialComponent({ testimonial }: ProjectTestimonialProps) {
  if (!testimonial) return null

  return (
    <div className="my-12">
      <div className="bg-muted/30 border-primary rounded-r-lg border-l-4 p-8">
        <blockquote className="text-foreground mb-4 text-xl italic">&quot;{testimonial.quote}&quot;</blockquote>
        <footer className="text-muted-foreground text-sm">
          <strong className="text-foreground">{testimonial.author}</strong>
          {testimonial.role && `, ${testimonial.role}`}
        </footer>
      </div>
    </div>
  )
}
